import React from 'react';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';

import styles from './styles.scss';

import Accordion, {
  AccordionContent,
  AccordionTitle
} from 'buyside/components/presentation/Accordion/accordionComponents';

const CollapsiblePanel: React.FC<{
  children?: React.ReactNode;
  dataTag?: string;
  title: JSX.Element | string;
}> = ({ dataTag = '', title, children }): React.ReactElement => (
  <Accordion initialOpen={false}>
    <AccordionTitle
      expandable
      expandIcon={faAngleDown}
      dataTag={dataTag}
      iconStyles={styles.icon}
      collapseIcon={faAngleUp}
      titleStyles={styles.header}
    >
      {title}
    </AccordionTitle>
    <AccordionContent>{children}</AccordionContent>
  </Accordion>
);

export default CollapsiblePanel;
